/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddTariffLineItemRequest } from '../models/AddTariffLineItemRequest';
import type { CarrierDocumentType } from '../models/CarrierDocumentType';
import type { CarrierTariff } from '../models/CarrierTariff';
import type { CarrierVehicleReviewRequest } from '../models/CarrierVehicleReviewRequest';
import type { GetCarrierResponse } from '../models/GetCarrierResponse';
import type { GetCarrierSaferResponse } from '../models/GetCarrierSaferResponse';
import type { GetCarrierUcrStatusResponse } from '../models/GetCarrierUcrStatusResponse';
import type { ListOperationTypesResponse } from '../models/ListOperationTypesResponse';
import type { MotorCarrier } from '../models/MotorCarrier';
import type { MotorCarrierAddress } from '../models/MotorCarrierAddress';
import type { SaferCarrierAddresses } from '../models/SaferCarrierAddresses';
import type { StoredDocument } from '../models/StoredDocument';
import type { UpdateTariffRequest } from '../models/UpdateTariffRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MotorCarriersService {
  /**
   * Get a single carrier by its Certificate ID.
   * @param certificateId
   * @returns GetCarrierResponse OK
   * @throws ApiError
   */
  public static getCarrierByCertificateId(
    certificateId: string,
  ): CancelablePromise<GetCarrierResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/certificate/{certificateId}',
      path: {
        'certificateId': certificateId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a single carrier by its ID.
   * @param id
   * @returns GetCarrierResponse OK
   * @throws ApiError
   */
  public static getCarrier(
    id: string,
  ): CancelablePromise<GetCarrierResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a single carrier's SAFER data by its ID.
   * @param id
   * @returns GetCarrierSaferResponse OK
   * @throws ApiError
   */
  public static getCarrierSafer(
    id: string,
  ): CancelablePromise<GetCarrierSaferResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{id}/safer',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a single carrier's UCR registration status by its ID and optional registration year. If year is not provided, the current year is used.
   * @param id
   * @param registrationYear
   * @returns GetCarrierUcrStatusResponse OK
   * @throws ApiError
   */
  public static getCarrierUcrStatus(
    id: string,
    registrationYear?: number,
  ): CancelablePromise<GetCarrierUcrStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{id}/ucr',
      path: {
        'id': id,
      },
      query: {
        'registrationYear': registrationYear,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @param carrierId
   * @returns SaferCarrierAddresses OK
   * @throws ApiError
   */
  public static getApiMotorCarriersGetMcs150Addresses(
    carrierId?: string,
  ): CancelablePromise<SaferCarrierAddresses> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/get-mcs150-addresses',
      query: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get carrier addresses by carrier ID
   * @param carrierId
   * @returns MotorCarrierAddress OK
   * @throws ApiError
   */
  public static getCarrierAddresses(
    carrierId: string,
  ): CancelablePromise<Array<MotorCarrierAddress>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/addresses',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Save a single carrier address.
   * @param carrierId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static saveCarrierAddress(
    carrierId: string,
    requestBody?: MotorCarrierAddress,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarriers/{carrierId}/addresses',
      path: {
        'carrierId': carrierId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update carrier information
   * @param carrierId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static updateCarrier(
    carrierId: string,
    requestBody?: MotorCarrier,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/MotorCarriers/{carrierId}',
      path: {
        'carrierId': carrierId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a single carrier address by its ID.
   * @param addressId
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCarrierAddress(
    addressId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/MotorCarriers/addresses/{addressId}',
      path: {
        'addressId': addressId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get the tax ID of a specific carrier by ID
   * @param carrierId
   * @returns string OK
   * @throws ApiError
   */
  public static getTaxId(
    carrierId: string,
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/tax-id',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get the MCS-150 email address of a specific carrier by ID
   * @param carrierId
   * @returns string OK
   * @throws ApiError
   */
  public static getMcs150Email(
    carrierId: string,
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/mcs150-email',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get the standard tariff line items for a carrier
   * @param carrierId
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static getCarrierTariffs(
    carrierId: string,
  ): CancelablePromise<Array<CarrierTariff>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/tariffs',
      path: {
        'carrierId': carrierId,
      },
    });
  }
  /**
   * Add a standard tariff line item to a carrier
   * @param carrierId
   * @param requestBody
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static addCarrierTariff(
    carrierId: string,
    requestBody?: AddTariffLineItemRequest,
  ): CancelablePromise<CarrierTariff> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarriers/{carrierId}/tariffs',
      path: {
        'carrierId': carrierId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Get the carrier's standard tariff line items as a PDF
   * @param carrierId
   * @returns binary OK
   * @throws ApiError
   */
  public static getCarrierTariffsPdf(
    carrierId: string,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/tariffs/pdf',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update the description and amount of a standard tariff line item for a carrier
   * @param carrierId
   * @param tariffId
   * @param requestBody
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static updateCarrierTariff(
    carrierId: string,
    tariffId: string,
    requestBody?: UpdateTariffRequest,
  ): CancelablePromise<CarrierTariff> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/MotorCarriers/{carrierId}/tariffs/{tariffId}',
      path: {
        'carrierId': carrierId,
        'tariffId': tariffId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a standard tariff line item from a carrier
   * @param carrierId
   * @param tariffId
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCarrierTariff(
    carrierId: string,
    tariffId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/MotorCarriers/{carrierId}/tariffs/{tariffId}',
      path: {
        'carrierId': carrierId,
        'tariffId': tariffId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Upload a carrier document to S3.
   * @param carrierId
   * @param documentType
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadMotorCarrierDocument(
    carrierId: string,
    documentType: CarrierDocumentType,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarriers/{carrierId}/uploads/{documentType}',
      path: {
        'carrierId': carrierId,
        'documentType': documentType,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Get carrier document metadata, if one exists, for a document type.
   * @param carrierId
   * @param documentType
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getMotorCarrierDocument(
    carrierId: string,
    documentType: CarrierDocumentType,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/uploads/{documentType}',
      path: {
        'carrierId': carrierId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a carrier document for a document type.
   * @param carrierId
   * @param documentType
   * @returns void
   * @throws ApiError
   */
  public static deleteMotorCarrierDocument(
    carrierId: string,
    documentType: CarrierDocumentType,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/MotorCarriers/{carrierId}/uploads/{documentType}',
      path: {
        'carrierId': carrierId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stream a carrier document for preview or download.
   * @param carrierId
   * @param documentType
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadMotorCarrierDocument(
    carrierId: string,
    documentType: CarrierDocumentType,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/uploads/{documentType}/content',
      path: {
        'carrierId': carrierId,
        'documentType': documentType,
      },
      query: {
        'download': download,
      },
    });
  }
  /**
   * List all carrier operation types.
   * @returns ListOperationTypesResponse OK
   * @throws ApiError
   */
  public static listOperationTypes(): CancelablePromise<ListOperationTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/operation-types',
    });
  }
  /**
   * List the vehicle review requests this carrier made, on any of its certificates or applications, without cancelled ones
   * @param carrierId
   * @returns CarrierVehicleReviewRequest OK
   * @throws ApiError
   */
  public static listCarrierVehicleReviewRequests(
    carrierId: string,
  ): CancelablePromise<Array<CarrierVehicleReviewRequest>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/vehicle-review-requests',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Download or preview a supporting document on one of this carrier's vehicle review requests
   * @param carrierId
   * @param requestId
   * @param documentId
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static getCarrierVehicleReviewRequestDocumentContent(
    carrierId: string,
    requestId: string,
    documentId: string,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarriers/{carrierId}/vehicle-review-requests/{requestId}/documents/{documentId}/content',
      path: {
        'carrierId': carrierId,
        'requestId': requestId,
        'documentId': documentId,
      },
      query: {
        'download': download,
      },
      errors: {
        302: `Found`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Add supporting documents to one of this carrier's vehicle review requests while it awaits a decision. Documents are never removed.
   * @param carrierId
   * @param requestId
   * @param formData
   * @returns void
   * @throws ApiError
   */
  public static addCarrierVehicleReviewRequestDocuments(
    carrierId: string,
    requestId: string,
    formData?: {
      Files?: Array<Blob>;
    },
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarriers/{carrierId}/vehicle-review-requests/{requestId}/documents',
      path: {
        'carrierId': carrierId,
        'requestId': requestId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Cancel one of this carrier's vehicle review requests while it awaits a decision. Its documents are kept.
   * @param carrierId
   * @param requestId
   * @returns void
   * @throws ApiError
   */
  public static cancelCarrierVehicleReviewRequest(
    carrierId: string,
    requestId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarriers/{carrierId}/vehicle-review-requests/{requestId}/cancel',
      path: {
        'carrierId': carrierId,
        'requestId': requestId,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
}
